module.exports = __webpack_public_path__ + "media/Sound-of-coin.08becfc9.mp3";